import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SidebarComponent } from '../../../common/sidebar/sidebar.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DtcOverviewComponent } from '../dtc-overview/dtc-overview.component';
import { DtcTableComponent } from '../../../tables/dtc/dtc-table/dtc-table.component';

@Component({
  selector: 'app-dtc-recycling-overview',
  imports: [SidebarComponent, CommonModule, RouterModule, DtcTableComponent],
  templateUrl: './dtc-recycling-overview.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dtc-recycling-overview.component.scss',
})
export class DtcRecyclingOverviewComponent extends DtcOverviewComponent implements OnInit, OnDestroy {
  constructor() {
    super();
    this.recyclingModeEnabled = true;
  }
  public override ngOnInit(): void {
    super.ngOnInit();
    this.sidebarConfiguration.editAreaEnabled = false;
    this.sidebarConfiguration.translationsAreaEnabled = false;
  }

  protected override configureReviewsEnabled(): void {
    this.sidebarConfiguration.reviewAreaEnabled = false;
  }

  protected override configureMergeReviewsEnabled(): void {
    this.sidebarConfiguration.mergeReviewAreaEnabled = false;
  }
}
